<template>
    <div :class="'alert '+announcementType+' alert-with-icon alert-dismissible fade show announcement_banner'" v-if="!closeNow && !hide" data-notify="container">
        <span data-notify="icon" class="nc-icon nc-bell-55"></span>

        <i class="fa fa-times pull-right click-cursor" @click="closeAnnouncement" />
        <div data-notify="message" class="announcement_msg" v-html="announcementText"></div>
    </div>
</template>

<script>
    import {db} from "@/firebase/init";
    export default {
        name: "Announcements",
      data () {
        return {
          closeNow: false
        };
      },
        computed: {
            announcementListener () {
                return this.$store.getters['notification/getAnnouncementListener'];
            },
            announcementText () {
                return this.$store.getters['notification/getAnnouncementText'];
            },
            announcementType () {
                return this.$store.getters['notification/getAnnouncementType'];
            },
            docId () {
                return this.$store.getters['notification/getAnnouncementDocId'];
            },
            hide () {
              if (!this.docId) {
                return true;
              }
              if (this.docId === 'deployed') {
                return this.$cookie.get('reloaded');
              }
              if (this.$cookie.get('reloaded') && this.docId && this.docId === this.$cookie.get('reloaded')) {
                return true;
              } else {
                this.closeNow = false;
                this.$cookie.delete('reloaded');
                return false;
              }
            }
        },
        mounted() {
            if(!this.announcementListener) {
                console.log('SnapShotOn init Announcements');
                let announcementQuery = db.collection('announcements').where('enabled', '==', true);
                const listener = announcementQuery.onSnapshot(querySnapshot => {
                    querySnapshot.docChanges().forEach(change => {
                        if(change.type === 'added' || change.type === 'modified') {
                            console.log(change.doc.data());
                            this.$store.commit('notification/mutateAnnouncementText', change.doc.data().text);
                            this.$store.commit('notification/mutateAnnouncementType', change.doc.data().type);
                            this.$store.commit('notification/mutateAnnouncementDocId', change.doc.id);
                        }else if(change.type === 'removed') {
                            console.log(change.doc.data());
                            this.$store.commit('notification/mutateAnnouncementText', '');
                            this.$store.commit('notification/mutateAnnouncementType', '');
                        }

                    })
                });
                this.$store.commit('notification/mutateAnnouncementListener', listener);
            }
        },
      methods: {
        closeAnnouncement () {
          if (this.docId) {
            this.closeNow = true;
            this.$cookie.set('reloaded', this.docId, {
              maxAge: 60 * 60 * 24 * 7,
              path: '/'
            });
          }
        }
      }
    }
</script>

<style>
    .announcement_msg p{
        margin-bottom: 0 !important;
    }
</style>

<style scoped>
.announcement_banner{
    border-radius: 0;
    margin-bottom: 0;
}
.click-cursor{
  cursor: pointer;
}
.announcement_msg{
    max-width: 100% !important;
}

</style>
